<template>
    <div class="page-layout">
       <div class="page-layout__row m-auto">
           <div class="ui-kit__section-wrap">
               <section class="ui-kit-section">
                   <div class="ui-kit-section__header">
                       <h2 class="ui-kit__subtitle">{{getTranslation('pageNotFound')}}</h2>
                   </div>
                   <div class="ui-kit-section__body">
                       <AlertComponent :text="getTranslation('pageNotFound')" :status="404"/>
                   </div>
               </section>
           </div>
       </div>
    </div>
</template>

<script>
    export default {
        name: "Error404"
    }
</script>

<style scoped>

</style>